import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";

import PostIcons from "../components/PostIcons";
import PaginatedPage from "./index.paginate";

const Home = ({ group }) => (
    <section className="row posts-loop ">
        {group.map(({ node }) => (
            <div className="post-wrapper col-12" key={node.slug}>
                <article className="list-post post type-post status-publish format-standard hentry">
                    <div className="entry-header">
                        <PostIcons node={node} className="entry-meta" />
                        <h2 className="entry-title">
                            <Link to={`/${node.slug}`} dangerouslySetInnerHTML={{ __html: node.title }} />
                        </h2>
                    </div>
                    <div className="entry-summary">
                        <span dangerouslySetInnerHTML={{ __html: node.body.childMarkdownRemark.excerpt + ' [...] ' }}></span>
                        <span className="read-more-link"><Link to={`/${node.slug}`} className="read-more">Read More</Link></span>
                    </div>
                </article>
            </div>
        ))}
    </section>
);

export default PaginatedPage(Home);


// WEBPACK FOOTER //
// ./src/templates/index.js